import { render, staticRenderFns } from "./startReferral.vue?vue&type=template&id=10d82587&scoped=true"
import script from "./startReferral.vue?vue&type=script&lang=js"
export * from "./startReferral.vue?vue&type=script&lang=js"
import style0 from "./startReferral.vue?vue&type=style&index=0&id=10d82587&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d82587",
  null
  
)

export default component.exports